import { useFormik } from "formik"
import InputNumber from "global/InputNumber/InputNumber"
import InputText from "global/InputText/InputText"
import Modal from "global/Modal/Modal"
import SimpleButton from "global/SimpleButton/SimpleButton"
import { linkPaymentValidation } from "global/Validation/Validation"
import { addEditDataAPI } from "services/CRUDServices"

function LinkPayment({ open, setOpen, payData, type, api, callBack }) {
  const {
    handleSubmit,
    isSubmitting,
    errors,
    handleChange,
    touched,
    values,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: linkPaymentValidation,
    initialValues: { ...payData },
    onSubmit: async () => {
      try {
        const DTO = {
          ...payData,
          debt: type === "credit" || type === "order"  ? +values.price : undefined,
          price:type === "credit" || type === "order"  ? undefined : +values.price,
          mobile:values.mobile
        }

        await addEditDataAPI(api, "post", DTO)
        setOpen(false)
        callBack()
      } catch {}
    },
  })

  return (
    <Modal visible={open} setVisible={setOpen} title='پرداخت از طریق لینک'>
      <form onSubmit={handleSubmit}>
        <div className='text-base flex flex-col  justify-center w-96'>
          <InputText
            dir='ltr'
            label='موبایل'
            name='mobile'
            handleChange={handleChange}
            values={values.mobile}
            important
            error={touched?.mobile && errors?.mobile}
            wrapperClassName='w-full'
            maxLength={13}
          />
          <InputNumber
            className='mt-4'
            label='مبلغ (ریال)'
            name='price'
            handleChange={setFieldValue}
            values={values.price}
            important
            error={touched.price && errors.price}
            wrapperClassName='w-full'
            readOnly={type === "order"}
          />
        </div>

        <div className='btnForm justify-center'>
          <SimpleButton
            type='submit'
            text=' ارسال لینک پرداخت'
            className='full-tomato-btn   w-60'
            loading={isSubmitting}
          />
        </div>
      </form>
    </Modal>
  )
}

export default LinkPayment
